import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { classNames } from '../common/utils/utils';

interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  width?: string;
  closeButtonId?: string;
  closeOnlyOnButton?: boolean;
}

const Modal = ({ children, title, width, onClose, closeButtonId, closeOnlyOnButton }: ModalProps) => {
  return (
    <Transition.Root show={true} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeOnlyOnButton ? () => { } : onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-cool-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  'relative flex gap-[1rem] flex-col bg-white rounded-lg p-6 text-left  shadow-section transform transition-all w-full',
                  width ? width : 'sm:max-w-lg',
                )}
              >
                <div className="flex flex-col">
                  <div className="flex flex-row-reverse">
                    <button
                      tabIndex={9999}
                      id={closeButtonId}
                      className="bg-white rounded-md text-cool-gray-900 hover:text-cool-gray-500 focus:outline-none focus:shadow-blue"
                      onClick={onClose}
                      aria-label="close-modal"
                      type="button"
                    >
                      <XMarkIcon className="h-6 w-6" />
                    </button>
                  </div>
                  {title && (
                    <Dialog.Title
                      as="h1"
                      className="sm:text-lg lg:text-2xl text-center leading-6 font-roboto truncate"
                    >
                      {title}
                    </Dialog.Title>
                  )}
                </div>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Modal;
